/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <div class="marginBottom">订单号：{{ selectedInfo.OrderID }}</div>
    <el-button class="marginBottom">基础信息</el-button>
    <div class="marginBottom border lineHeight grayBgBox">
      <div class="flex borderBottom">
        <div class="grayBg">订单时间</div>
        {{ selectedInfo.CREATETIME }}
      </div>
      <div class="flex borderBottom">
        <div class="grayBg">客户名称</div>
        {{ selectedInfo.UserName||selectedInfo.Consignee }}
      </div>
      <div class="flex borderBottom">
        <div class="grayBg">联系方式</div>
        {{ selectedInfo.UserTel||selectedInfo.ContactInformation }}
      </div>
      <div class="flex borderBottom">
        <div class="grayBg">详细地址</div>
        {{ selectedInfo.UserAddress||selectedInfo.ShippingAddress }}
      </div>
      <div class="flex borderBottom">
        <div class="grayBg">支付方式</div>
        {{ selectedInfo.PayWay||''}}
      </div>
      <div class="flex">
        <div class="grayBg">备注</div>
        {{ selectedInfo.Remark||'' }}
      </div>
    </div>
    <el-button class="marginBottom">商品信息</el-button>

    <el-table
      size="small"
      :data="details"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="CommodityName"
        label="商品名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="UnitPrice"
        label="单价"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="OrderState"
        label="状态"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="CommodityNum"
        label="数量"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="FTicketValue"
        label="礼券"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="FullReductionAmount"
        label="满减"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="OrderAmount"
        label="金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="CREATETIME"
        label="下单时间"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
let flag = true;
export default {
  data() {
    return {
      CSetting: this.$Url + "BSetting/",
      goodUrl: this.$goodUrl,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      selectedInfo: {},
      details: [],
      from:'',
    };
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.selectedInfo = JSON.parse(this.$route.query.item);
    console.log(this.$route,this.selectedInfo, 111);
    this.from = this.$route.query.from;
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
    this.toDetail()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    toDetail(e) {
      this.$loading();
      this.$api
        .QueryDataFn1("Web\\GetOrderInfo_1_0_2&DBC=r_b1", {
          OrderGUID: this.selectedInfo.OrderGUID,
        })
        .then((res) => {
          let result = res.data,
            list = [];
          this.$loading().close();
          if (result.OK != "True") {
            this.$message({
              message: result.Message,
              type: "success",
            });
          } else if (result.Tag.length <= 0) {
          } else {
            list = result.Tag[0].Table;
          }
          this.details = list;
          this.editFormVisible = true;
        });
    },
  },
};
</script>

<style scoped >
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.eltable {
  border: 1px solid #ebeef5;
  max-height: 71vh;
  margin-bottom: 10px;
  overflow-y: scroll;
}
.title {
  border-bottom: 1px solid #ebeef5;
  line-height: 2;
  padding: 20px;
}
.grayBg {
  background: #eee;
  display: inline-block;
  width: 100px;
  padding: 0 20px;
  margin-right: 20px;
  border-right: 1px solid #ebeef5;
  text-align: center;
}
.grayBgBox {
  width: 500px;
  line-height: 3;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/orderDetail.vue